import React, { useContext, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { Button } from '@mui/material';
import HtmlForm from '../strategyForm/htmlForm';
import { LOCALES } from '../../i18n';
import { AppContext } from '../context';
import { getQuestionSuivateByQuestionId } from '../../services/requestHandler';
import translate from '../../i18n/translate';

const default_color = "#8EBF55";

export default function ShowStrategie() {
  const params = useParams();
  const {state} = useContext(AppContext);

  const [strategieText, setStrategieText] = useState("");
  const [titleText, setTitleText] = useState("");
  const [strategieData, setStrategieData] = useState([]);

  React.useEffect(() => {
  getStrategie(params.questionId)
  // eslint-disable-next-line
  },[params.questionId])

  async function getStrategie(id) {
    const data = await getQuestionSuivateByQuestionId(id)
    if (data) {
      setStrategieData(data)
    }    
  }
  
  React.useEffect(() => {
    console.log("data", strategieData)
    if (strategieData.length !== 0) {
      console.log("strategy not empty")
      if(state.locale === LOCALES.FRENCH) {
        setStrategieText(strategieData.strategies[0].contenu)
        setTitleText(strategieData.contenu)
      }
      else if(state.locale === LOCALES.ENGLISH) {
        setStrategieText(strategieData.strategies[0].contenu_en)
        setTitleText(strategieData.contenu_en)
      }
    }
  },[strategieData, state.locale])

  return (
    <main style={{display: "grid", justifyItems: "center"}}>
        <h1 id="mainQuestion" style={{marginTop: "25px", maxWidth: "80%", color: "black", fontSize: "36px"}}> {titleText}</h1>
          <Card sx={{ backgroundColor: default_color, maxWidth: "60%"}} >
            <CardContent style={{ display: "flex"}}>
                <div style={{ display: "flex", justifyContent: "center"}}>
                  <HtmlForm strategieTemp={strategieText}/>
                </div>
            </CardContent>
          </Card>
          <Link to="/strategies" style={{textDecoration: 'none'}}>
            <Button variant="contained" 
            sx={{backgroundColor: "#307B5B", "&:hover": {backgroundColor: "#8EBF55", color: "black", fontWeight: "bold"}}}
            style={{ marginTop: "2rem", width: "15rem"}}> 
            {translate("historique.retourStrategie")} </Button>
          </Link>
    </main>
  );
}